const getLessonAssignmentData = ({ name, language, activities }) => ({
    label: name,
    tasks: activities.map(({ name, spanishName, contentID, previewURL, entity }) => ({
      language,
      contentID,
      previewURL,
      name: language === 'es' ? spanishName : name,
      contentType: entity,
    })),
    instructions: activities.map(t => language === 'es' ? t.spanishLearningObjectiveHTML : t.learningObjectiveHTML),
});

const getModuleAssignmentData = ({ contentID, language, name, spanishName, learningObjectiveHTML, spanishLearningObjectiveHTML, previewURL, entity }) => ({
    label: language === 'es' ? spanishName : name,
    tasks: [{
      contentID,
      previewURL,
      name: language === 'es' ? spanishName : name,
      language: language === 'en_es' ? 'any' : language,
      contentType: entity,
    }],
    instructions: [language === 'es' ? spanishLearningObjectiveHTML : learningObjectiveHTML],
});

const getResourceAssignmentData = (resource) => ({
	Lesson: getLessonAssignmentData,
	Book: getModuleAssignmentData,
	Game: getModuleAssignmentData,
}[resource.entity] ?? (() => {}))(resource);

export default getResourceAssignmentData;
